const postMessageToParent = (
  data: { accessToken: string; refreshToken: string; client_id: string },
  origin: string = '*'
) => {
  if (typeof window !== 'undefined') {
    window.parent.postMessage(data, origin);
  }
};
export default postMessageToParent;
